import { lazy } from "react";

const Main = lazy(() => import("../src/main"));
const AddressApp = lazy(() => import("../src/startup/address.app"));
const AdminNotesApp = lazy(() => import("../src/startup/admin-notes.app"));
const AdminVerifyApp = lazy(() => import("../src/startup/admin-verify.app"));
const AdministratorsFiltersApp = lazy(() => import("../src/startup/administrators-filters.app"));
const AnimatedSelectorPhraseApp = lazy(() => import("../src/startup/animated-selector-phrase.app"));
const AvailabilitiesGraphApp = lazy(() => import("../src/startup/availabilities-graph.app"));
const BannerApp = lazy(() => import("../src/startup/banner.app"));
const BecomeJobberTitleApp = lazy(() => import("../src/startup/become-jobber-title.app"));
const CalendarApp = lazy(() => import("../src/startup/calendar.app"));
const CategoriesNavigationModalApp = lazy(
  () => import("../src/startup/categories-navigation-modal.app")
);
const ContactFilePickerApp = lazy(() => import("../src/startup/contact-file-picker.app"));
const DatePickerApp = lazy(() => import("../src/startup/datepicker.app"));
const DlApp = lazy(() => import("../src/startup/dl-app.app"));
const HeaderMenuApp = lazy(() => import("../src/startup/header-menu.app"));
const ImageGalleryApp = lazy(() => import("../src/startup/image-gallery.app"));
const ImageManipulationApp = lazy(() => import("../src/startup/image-manipulation.app"));

const JobberSearchApp = lazy(() => import("../src/startup/jobber-search.app"));
const JobberSelectionTutorialApp = lazy(
  () => import("../src/startup/jobber-selection-tutorial.app")
);
const JobbersSeoSearchBarApp = lazy(() => import("../src/startup/jobbers-seo-search-bar.app"));
const LoginOrRegister = lazy(() => import("../src/startup/login-or-register.app"));
const LostTimeSimulatorApp = lazy(() => import("../src/startup/lost-time-simulator.app"));
const MapStandaloneApp = lazy(() => import("../src/startup/map-standalone.app"));
const MovingBoxesCalculatorApp = lazy(() => import("../src/startup/moving-boxes-calculator.app"));
const MovingVolumeCalculatorApp = lazy(() => import("../src/startup/moving-volume-calculator.app"));
const PhoneNumberApp = lazy(() => import("../src/startup/phone-number.app"));
const ProgressCircularApp = lazy(() => import("../src/startup/progress-circular.app"));
const PublishJobModalApp = lazy(() => import("../src/startup/publish-job-modal.app"));
const QrcodeGeneratorApp = lazy(() => import("../src/startup/qrcode-generator.app"));
const ReadMoreApp = lazy(() => import("../src/startup/read-more.app"));
const RemovalSearchApp = lazy(() => import("../src/startup/removal-search.app"));
const RoleFiltersApp = lazy(() => import("../src/startup/role-filters.app"));
const SearchBarApp = lazy(() => import("../src/startup/search-bar.app"));
const SelectApp = lazy(() => import("../src/startup/select.app"));
const SendTrackEventApp = lazy(() => import("../src/startup/send-track-event.app"));
const SeoZipCodeJobsAvailabilityApp = lazy(
  () => import("../src/startup/seo-zip-code-jobs-availability")
);
const TaxCreditSimulatorApp = lazy(() => import("../src/startup/tax-credit-simulator.app"));
const TimeRangeApp = lazy(() => import("../src/startup/time-range.app"));
const ToastsApp = lazy(() => import("../src/startup/toasts.app"));
const TruckVolumeSimulatorApp = lazy(() => import("../src/startup/truck-volume-simulator.app"));
const UserPreviewApp = lazy(() => import("../src/startup/user-preview.app"));
const VolumeCalculatorApp = lazy(() => import("../src/startup/volume-calculator.app"));
const ZipCodeApp = lazy(() => import("../src/startup/zip-code.app"));
const ZoomOnHover = lazy(() => import("../src/startup/zoom-on-hover.app"));

const GiftCardApp = lazy(() => import("../src/components/gift-card"));

export const oldComponents = {
  SearchBarApp,
  LoginOrRegister,
  JobberSelectionTutorialApp,
  JobbersSeoSearchBarApp,
  DlApp,
  ZoomOnHover,
  CategoriesNavigationModalApp,
  RoleFiltersApp,
  TaxCreditSimulatorApp,
  LostTimeSimulatorApp,
  ContactFilePickerApp,
  HeaderMenuApp,
  PublishJobModalApp,
  ReadMoreApp,
  ToastsApp,
  QrcodeGeneratorApp,
  DatePickerApp,
  CalendarApp,
  ZipCodeApp,
  AddressApp,
  ImageManipulationApp,
  PhoneNumberApp,
  UserPreviewApp,
  AdminNotesApp,
  AdminVerifyApp,
  AdministratorsFiltersApp,
  SendTrackEventApp,
  TimeRangeApp,
  SelectApp,
  ProgressCircularApp,
  ImageGalleryApp,
  SeoZipCodeJobsAvailabilityApp,
  BecomeJobberTitleApp,
  TruckVolumeSimulatorApp,
  RemovalSearchApp,
  AnimatedSelectorPhraseApp,
  AvailabilitiesGraphApp,
  MovingVolumeCalculatorApp,
  VolumeCalculatorApp,
  MovingBoxesCalculatorApp,
  JobberSearchApp,
  MapStandaloneApp,
  BannerApp,
  GiftCardApp,
};

export default {
  Main,
  ...oldComponents,
};
